import { formatEther } from '@ethersproject/units'
import { ChainId } from '@pancakeswap/chains'
import { Balance, ChevronDownIcon, Flex, FlexGap, OpenNewIcon, QuestionHelper, Text, useMatchBreakpoints, useModal } from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { ChainLogo } from 'components/Logo/ChainLogo'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { useSwitchNetwork } from 'hooks/useSwitchNetwork'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import { usePopper } from "react-popper"
import styled from 'styled-components'
import useSWRImmutable from 'swr/immutable'
import { CHAIN_IDS, chains } from 'utils/wagmi'
import { useAccount } from 'wagmi'
import { statsClients, v3Clients } from 'utils/graphql'
import { ChainDefaultId } from '@pancakeswap/sdk'
import { gql } from 'graphql-request'
import { useCurrentBlock } from 'state/block/hooks'
import { REWARD_RATIO } from 'config/constants'
import { useProtocolStats } from 'views/Liquidity/hooks/usePools'
import WalletModal from './UserMenu/WalletModal'

const StyledMenu = styled(Flex)`
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 120px;
  align-items: flex-start;
  justify-content: space-between;
  user-select: none;
  z-index: 10;
  ${({ theme }) => theme.mediaQueries.lg} {
    height: 150px;
  }
`

const StyledButton = styled(Flex)`
  align-items: center;
  cursor: pointer;
  padding: 8px;
  pointer-events: all;
  
  &:hover {
    border-radius: 16px 16px 0 0;
    background: #332D3E;
  }
`

const StyledPopup = styled(Flex)`
  color: white;
  border-radius: 16px 0 16px 16px;
  background: #332D3E;
  padding: 20px 0;
  & > * {
    padding: 4px 24px;
    &:hover {
      background: #332D3E;
    }
  }
`

const StyledAccount = styled(FlexGap)`
  cursor: pointer;
  pointer-events: all;
  padding: 4px 0px;
  &:hover {
    opacity: 0.65;
    // background: #332D3EA0;
    // border-radius: 16px;
  }
`

const StyledConnectButton = styled(ConnectWalletButton)`
  width: auto;
  pointer-events: all;
  height: 32px;
  font-size: 16px;
  align-self: center;
`

const StyledSubMenu = styled(Link) <{ selected?: boolean }>`
  font-size: 14px;
  ${({ theme, selected }) => `
    background: ${selected ? theme.colors.white : 'transparent'};
    color: ${selected ? theme.colors.primary : theme.colors.textSubtle};
    padding: 12px 24px;
    border-radius: 40px;
    &:hover {
      background: ${selected ? theme.colors.white : theme.colors.backgroundAlt};
    }
  `}
`

const StyledBottomMenu = styled(Link) <{ selected?: boolean }>`
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${({ theme, selected }) => `
    background: ${selected ? '#615677' : 'transparent'};
    color: ${selected ? theme.colors.primary : theme.colors.textSubtle};
    padding: 12px 24px;
    border-radius: 40px;
  `}
`

const BottomBar = styled(Flex)`
  position: fixed;
  height: 64px;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 2;
  background: #332D3E;
  justify-content: space-between;
  padding: 8px;
  gap: 8px;
`

const StatusBox = styled(Flex)`
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 2;
  align-items: flex-end;
  flex-direction: column;
  padding: 16px 24px;
  gap: 8px;
  pointer-events: none;
`

const SwapIcon = ({ color }: any) => (
  <svg width="29" height="28" viewBox="0 0 29 28" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M23.8919 11.7101C23.9581 11.5502 23.9755 11.3742 23.9417 11.2045C23.9079 11.0347 23.8245 10.8787 23.702 10.7564L19.327 6.38138C19.2463 6.29781 19.1498 6.23115 19.043 6.1853C18.9362 6.13944 18.8214 6.1153 18.7052 6.11429C18.5891 6.11328 18.4738 6.13542 18.3663 6.17942C18.2588 6.22341 18.1611 6.28838 18.0789 6.37054C17.9968 6.4527 17.9318 6.55039 17.8878 6.65792C17.8438 6.76546 17.8217 6.88068 17.8227 6.99686C17.8237 7.11304 17.8478 7.22786 17.8937 7.33461C17.9395 7.44137 18.0062 7.53792 18.0898 7.61863L20.9711 10.5L5.58339 10.5C5.35133 10.5 5.12877 10.5922 4.96468 10.7563C4.80058 10.9204 4.70839 11.1429 4.70839 11.375C4.70839 11.6071 4.80058 11.8296 4.96468 11.9937C5.12877 12.1578 5.35133 12.25 5.58339 12.25L23.0834 12.25C23.2564 12.2501 23.4256 12.1988 23.5695 12.1027C23.7134 12.0066 23.8256 11.87 23.8919 11.7101Z" />
    <path d="M10.5771 21.6186C10.7412 21.4545 10.8333 21.232 10.8333 21C10.8333 20.768 10.7412 20.5455 10.5771 20.3814L7.69575 17.5L23.0835 17.5C23.3156 17.5 23.5381 17.4078 23.7022 17.2437C23.8663 17.0796 23.9585 16.8571 23.9585 16.625C23.9585 16.3929 23.8663 16.1704 23.7022 16.0063C23.5381 15.8422 23.3156 15.75 23.0835 15.75L5.5835 15.75C5.41047 15.75 5.24133 15.8014 5.09747 15.8975C4.95361 15.9937 4.84149 16.1303 4.77528 16.2902C4.70907 16.45 4.69174 16.6259 4.72549 16.7957C4.75923 16.9654 4.84254 17.1213 4.96487 17.2436L9.33987 21.6186C9.50396 21.7827 9.72648 21.8748 9.9585 21.8748C10.1905 21.8748 10.413 21.7827 10.5771 21.6186Z" />
  </svg>
)

const LiquidityIcon = ({ color }: any) => (
  <svg width="20" height="28" viewBox="0 0 20 28" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5014 1.03289C10.3544 0.930117 10.1794 0.875 10 0.875C9.82064 0.875 9.64562 0.930117 9.49862 1.03289C9.125 1.29364 0.375 7.53326 0.375 17.4995C0.375 20.0522 1.38906 22.5004 3.1941 24.3054C4.99914 26.1105 7.44729 27.1245 10 27.1245C12.5527 27.1245 15.0009 26.1105 16.8059 24.3054C18.6109 22.5004 19.625 20.0522 19.625 17.4995C19.625 7.53326 10.875 1.29364 10.5014 1.03289ZM10 25.3745C7.9122 25.372 5.91064 24.5415 4.43435 23.0652C2.95805 21.5889 2.12755 19.5873 2.125 17.4995C2.125 9.76626 8.19312 4.30626 10 2.85201C11.8086 4.30189 17.875 9.74701 17.875 17.4995C17.8725 19.5873 17.042 21.5889 15.5657 23.0652C14.0894 24.5415 12.0878 25.372 10 25.3745Z" />
    <path d="M10 22.75C8.60804 22.7486 7.27349 22.195 6.28922 21.2108C5.30496 20.2265 4.75139 18.892 4.75 17.5C4.75 17.2679 4.65781 17.0454 4.49372 16.8813C4.32962 16.7172 4.10706 16.625 3.875 16.625C3.64294 16.625 3.42038 16.7172 3.25628 16.8813C3.09219 17.0454 3 17.2679 3 17.5C3.00208 19.3559 3.74025 21.1351 5.05255 22.4474C6.36486 23.7597 8.14412 24.4979 10 24.5C10.2321 24.5 10.4546 24.4078 10.6187 24.2437C10.7828 24.0796 10.875 23.8571 10.875 23.625C10.875 23.3929 10.7828 23.1704 10.6187 23.0063C10.4546 22.8422 10.2321 22.75 10 22.75Z" />
  </svg>
)

const PointsIcon = ({ color }: any) => (
  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1208_2938)">
      <path d="M11.19 7.32962L10.6633 10.4013C10.6105 10.7091 10.737 11.0202 10.9897 11.2037C11.1326 11.3075 11.3018 11.3605 11.4718 11.3605C11.6023 11.3605 11.7335 11.3293 11.8536 11.2663L14.6121 9.81598L17.3706 11.2663C17.4906 11.3293 17.6216 11.3605 17.7523 11.3605C17.753 11.3605 17.7538 11.3605 17.7547 11.3605C18.2071 11.3598 18.5737 10.9928 18.5737 10.5402C18.5737 10.4771 18.5667 10.4158 18.5532 10.3569L18.0341 7.32962L20.2658 5.15408C20.4895 4.93619 20.57 4.6102 20.4735 4.31326C20.3769 4.01633 20.1203 3.79993 19.8112 3.75507L16.7272 3.30689L15.3478 0.511841C15.2096 0.231995 14.9244 0.0546875 14.6121 0.0546875C14.3 0.0546875 14.0148 0.231995 13.8766 0.511841L12.4972 3.30667L9.41292 3.75485C9.10402 3.79993 8.84724 4.01633 8.7509 4.31326C8.65434 4.6102 8.73488 4.93619 8.95833 5.15408L11.19 7.32962ZM13.1599 4.86847C13.4271 4.82959 13.658 4.66168 13.7775 4.41965L14.6121 2.72861L15.4467 4.41965C15.5663 4.66168 15.7973 4.82959 16.0645 4.86847L17.9307 5.13956L16.5802 6.4559C16.3869 6.64432 16.2986 6.91583 16.3443 7.18179L16.6631 9.04053L14.9938 8.16296C14.8744 8.10016 14.7432 8.06876 14.6123 8.06876C14.4811 8.06876 14.35 8.10016 14.2305 8.16296L12.5613 9.04053L12.88 7.18201C12.9257 6.91583 12.8375 6.64432 12.6442 6.4559L11.2937 5.13956L13.1599 4.86847Z" fill={color} />
      <path d="M25.5951 18.5062H22.0805C21.5847 18.5062 21.1171 18.6271 20.7042 18.8398V16.2512C20.7042 14.5877 19.3509 13.2344 17.6874 13.2344H11.5367C9.87326 13.2344 8.51975 14.5877 8.51975 16.2512V16.6432C8.10681 16.4306 7.63919 16.3097 7.14359 16.3097H3.62906C1.96536 16.3095 0.612061 17.663 0.612061 19.3265V27.2344C0.612061 27.6873 0.979279 28.0545 1.43237 28.0545H27.7917C28.2448 28.0545 28.6121 27.6873 28.6121 27.2344V21.5232C28.6121 19.8597 27.2588 18.5062 25.5951 18.5062ZM2.25269 19.3265C2.25269 18.5677 2.87006 17.9501 3.62906 17.9501H7.14359C7.90237 17.9501 8.51975 18.5677 8.51975 19.3265V26.4141H2.25269V19.3265ZM10.1604 19.3265V16.2512C10.1604 15.4924 10.778 14.875 11.5367 14.875H17.6874C18.4462 14.875 19.0635 15.4924 19.0635 16.2512V26.4141H10.1604V19.3265ZM26.9714 26.4141H20.7042V21.5232C20.7042 20.7642 21.3215 20.1468 22.0805 20.1468H25.5951C26.3541 20.1468 26.9714 20.7642 26.9714 21.5232V26.4141Z" fill="#A39CB1" />
    </g>
    <defs>
      <clipPath id="clip0_1208_2938">
        <rect width="28" height="28" fill="white" transform="translate(0.666748)" />
      </clipPath>
    </defs>
  </svg>
)

const Background = styled.div`
  position: fixed;
  user-select: none;
  top: 0;
  left: 0;
  height: 120px;
  background: ${({ theme }) => theme.colors.background};
  mask-image: linear-gradient(0deg, transparent 0%, white 60%, white 100%);
  @media (max-width: 480px) {
    width: auto;
  }
  img {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
`

const PointsText = styled(Text)`
  font-size: 14px;
  color: white;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  margin: 0;
  padding: 0;
  pointer-events: auto; /* Ensure this element responds to pointer events */
  user-select: text; /* Make the text selectable */
  position: relative; /* Establish a stacking context */
  z-index: 3; /* Ensure it's above other elements */
`

const PointsBalance = styled(Balance)`
  cursor: pointer;
  pointer-events: auto; /* Ensure this element responds to pointer events */
  user-select: text; /* Make the text selectable */
  position: relative; /* Establish a stacking context */
  z-index: 3; /* Ensure it's above other elements */
`

const Icon = ({ color, size }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.99996 12.3337V8.33366M8.99996 6.33366V6.32699M16.3333 9.00033C16.3333 13.0504 13.05 16.3337 8.99996 16.3337C4.94987 16.3337 1.66663 13.0504 1.66663 9.00033C1.66663 4.95024 4.94987 1.66699 8.99996 1.66699C13.05 1.66699 16.3333 4.95024 16.3333 9.00033Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
};

export const StatusBar = () => {
  const { data: variables } = useProtocolStats()
  const { isDesktop } = useMatchBreakpoints()
  if (!variables || !isDesktop)
    return null
  return <StatusBox alignItems="baseline">
    <FlexGap gap="8px" alignItems="baseline">
      <Text fontSize={14} color="textSubtle">DEX Liquidity:</Text>
      <Balance value={Number(variables['pool-liquidity'])} decimals={0} prefix="$" pack />
    </FlexGap>
    <FlexGap gap="8px" alignItems="baseline">
      <Text fontSize={14} color="textSubtle">24H Volume:</Text>
      <Balance value={Number(variables['pool-volume24H'])} decimals={0} prefix="$" pack />
    </FlexGap>
  </StatusBox>
}

export const MenuBar = () => {
  const router = useRouter()

  const { isMobile, isTablet } = useMatchBreakpoints()
  const page = router.pathname

  return <>
    {
      (!isMobile && !isTablet) &&
      <FlexGap gap="8px" justifyContent="center" alignItems="flex-end" height="64px" mb={4} position="fixed" zIndex={11} left="50%" style={{ transform: "translate(-50%, 0)" }}>
        <StyledSubMenu selected={page === '/' || page === '/swap'} href="/">
          Swap
        </StyledSubMenu>
        <StyledSubMenu selected={page === '/liquidity'} href="/liquidity">
          Liquidity
        </StyledSubMenu>
        {/* <StyledSubMenu selected={page === '/rewards'} href="/rewards">
          Rewards
        </StyledSubMenu> */}
        {/* <StyledSubMenu selected={page === '/points'} href="/points">
          Points
        </StyledSubMenu> */}
      </FlexGap>
    }
    {
      (isMobile || isTablet) &&
      <BottomBar>
        <StyledBottomMenu selected={page === '/' || page === '/swap'} href="/">
          <SwapIcon color={page === '/' || page === '/swap' ? "white" : "#A39CB1"} />
        </StyledBottomMenu>
        <StyledBottomMenu selected={page === '/liquidity'} href="/liquidity">
          <LiquidityIcon color={page === '/liquidity' ? "white" : "#A39CB1"} />
        </StyledBottomMenu>
        {/* <StyledBottomMenu selected={page === '/rewards'} href="/rewards">
          <PointsIcon color={page === '/rewards' ? "white" : "#A39CB1"} />
        </StyledBottomMenu> */}
      </BottomBar>
    }
  </>
}

const NavBar = () => {
  const { address } = useAccount()
  const { chainId } = useActiveChainId()
  const { switchNetworkAsync } = useSwitchNetwork()

  const account = address ? `${address.substring(0, 2)}...${address.substring(address.length - 4)}` : null

  const { isMobile, isTablet } = useMatchBreakpoints()

  const [isOpen, setIsOpen] = useState(false)
  const [targetRef, setTargetRef] = useState<HTMLDivElement | null>(null)
  const [tooltipRef, setTooltipRef] = useState<HTMLDivElement | null>(null)
  const { styles, attributes, update } = usePopper(targetRef, tooltipRef, {
    strategy: "fixed",
    placement: "bottom-end",
    modifiers: [{ name: "offset", options: { offset: [0, 0] } }],
  })

  const [onPresentWalletModal] = useModal(<WalletModal />)

  useEffect(() => {
    if (isOpen && update) update();
  }, [isOpen, update])

  useEffect(() => {
    const showDropdownMenu = () => {
      setIsOpen(true);
    };

    const hideDropdownMenu = (evt: MouseEvent | TouchEvent) => {
      const target = evt.target as Node;
      if (target && !tooltipRef?.contains(target)) {
        setIsOpen(false);
        evt.stopPropagation();
      }
    };

    targetRef?.addEventListener("mouseenter", showDropdownMenu);
    targetRef?.addEventListener("mouseleave", hideDropdownMenu);

    return () => {
      targetRef?.removeEventListener("mouseenter", showDropdownMenu);
      targetRef?.removeEventListener("mouseleave", hideDropdownMenu);
    };
  }, [targetRef, tooltipRef, setIsOpen])

  const supportedChains = chains.filter((chain) => CHAIN_IDS.includes(chain.id as ChainId))

  const { data: me } = useSWRImmutable(
    [`reward/me`, address],
    async () => {
      const { user } = await statsClients[ChainDefaultId].request<{ user: any }>(gql`
          query {
              user:point (id: "${address?.toLowerCase()}") {
                  points amount blockNumber
              }
          }
      `)
      if (!user)
        return undefined
      return {
        points: Number(user.points),
        amount: Number(user.amount),
        block: Number(user.blockNumber),
      }
    },
    {
      refreshInterval: 10_000,
      keepPreviousData: false,
    }
  )

  const blockNumber = useCurrentBlock()

  const points = useMemo(() => {
    if (!me)
      return 0
    return (me.points + (blockNumber - me.block) * me.amount) * REWARD_RATIO
  }, [me, blockNumber])

  return <StyledMenu p={['16px 10px', '20px 24px']}>
    <Background>
      <img src="/assets/bg1.png" alt="" />
    </Background>
    <Flex height="40px" alignItems="center" position="relative" zIndex={2}>
      <Link href="/" style={{ pointerEvents: 'all' }}>
        <img src="/logo.svg" alt="" />
      </Link>
    </Flex>
    <Flex justifyContent="flex-end" position="relative" zIndex={3} alignItems="center">
      {
        (address && (!isMobile && !isTablet)) &&
        <FlexGap gap="4px" mr="8px" alignItems="center" style={{ pointerEvents: 'auto' }}>

          {/* <FlexGap gap="8px" alignItems="baseline">
            <PointsText>Your Points:</PointsText>
            <PointsBalance bold
              color="#2EBF43"
              fontSize={16}
              decimals={
                Number(points) < 1000 ? 4 :
                  Number(points) < 10000 ? 2 :
                    Number(points) < 10000000 ? 3 :
                      4
              }
              value={Number(points)}
              pack />
          </FlexGap>
          <QuestionHelper placement="top"
            icon={<Icon color="#B99BF4" size={16} />}
            text={
              <PointsText>When you stake your LP, you earn Points for every block. Your LP still earns fees while staked, you can unstake at anytime with no penalty</PointsText>
            }
          /> */}

        </FlexGap>
      }
      <StyledButton
        ref={setTargetRef}
        onTouchStart={() => {
          setIsOpen((s) => !s);
        }}
      >
        <ChainLogo chainId={chainId} width={24} />
        <ChevronDownIcon width={24} />
        {
          isOpen &&
          <StyledPopup style={styles.popper} ref={setTooltipRef} {...attributes.popper} flexDirection='column' onClick={() => setIsOpen(false)}>
            {
              supportedChains.map(chain =>
                <FlexGap key={chain.id} gap="8px" alignItems="center" onClick={() => chain.id !== chainId && switchNetworkAsync(chain.id)}>
                  <ChainLogo chainId={chain.id} width={32} height={32} />
                  <Text fontSize={16} lineHeight={1}>{chain.name}</Text>
                </FlexGap>
              )
            }
            <FlexGap gap="8px" alignItems="center" as={Link} href="https://bridge.pulsechain.com" target="_blank" rel="noopener noreferrer">
              <Text color="#9168E4" fontSize={14} lineHeight="32px">Bridge to PulseChain</Text>
              <OpenNewIcon color="#777" width={18} />
            </FlexGap>
          </StyledPopup>
        }
      </StyledButton>
      {
        address
          ? <StyledAccount gap="8px" alignItems="center" onClick={onPresentWalletModal}>
            <img src="/assets/wallet.svg" width={18} alt="" />
            <Text fontSize={13} lineHeight={1}>{account}</Text>
          </StyledAccount>
          : <StyledConnectButton />
      }
    </Flex>
  </StyledMenu>
}

export default NavBar